import type { cssVar } from '@core/styles/tools'

/**
 * List of storyblock variables.
 */
export const VARIABLES: Array<Parameters<typeof cssVar>> = [
  ['--storyblock-background', { external: true }],
  ['--storyblock-border-radius', { external: true }],
]
